import { PublicModulesRouteMap } from '@/new-router/public-modules'
import { OperationsManagementRouteMap } from '@/new-router/operations-management'

const log = () => import('@/views/Monitor/log')
const statistics = () => import('@/views/Monitor/statistics')
const shareLinkStatistics = () => import('@/views/Monitor/shareLinkStatistics')
const Home = () => import('@/views/Home/home')
const cardFrameMonitoring = () => import('@/views/Monitor/cardFrameMonitoring')
const messageMonitoring = () => import('@/views/Monitor/messageMonitoring')
const operation = () => import('@/views/Monitor/operation')
const channelClassification = () => import('@/views/Monitor/register-source-management')
const cardFrameDetails = () => import('@/views/Monitor/card-frame-details')
/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
**/

export default [
  {
    path: '/monitor',
    name: 'monitor',
    component: Home,
    meta: {
      title: '平台监控',
      icon: 'icon-monitor',
      showSubiems: false,
      sort: 10,
      modules: 'monitor',
      permission: 'monitor:root',
    },
    children: [
      {
        path: 'log',
        name: 'log',
        component: log,
        meta: {
          title: '操作记录',
          active: ['log'],
          permission: 'monitor:operate',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PlatformMonitor],
        },
      },
      {
        path: 'operation',
        name: 'operation',
        component: operation,
        meta: {
          title: '平台操作记录',
          active: ['operation'],
          permission: 'monitor:operate:platform',
          nocache: true,
        },
      },
      {
        path: 'statistics',
        name: 'monitorStatistics',
        component: statistics,
        meta: {
          title: '注册来源统计',
          active: ['monitorStatistics'],
          permission: 'monitor:register',
          belong: [OperationsManagementRouteMap.OperationsManagement, OperationsManagementRouteMap.PlatformStatistics],
        },
      },
      {
        path: 'shareLinkStatistics',
        name: 'shareLinkStatistics',
        component: shareLinkStatistics,
        meta: {
          title: '分享链接统计',
          active: ['shareLinkStatistics'],
          permission: 'monitor:share',
          belong: [OperationsManagementRouteMap.OperationsManagement, OperationsManagementRouteMap.PlatformStatistics],
        },
      },
      {
        path: 'cardFrameMonitoring',
        name: 'cardFrameMonitoring',
        component: cardFrameMonitoring,
        meta: {
          title: '卡帧监控',
          active: ['cardFrameMonitoring'],
          permission: 'monitor:platform',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PlatformMonitor],
        },
      },
      {
        path: 'messageMonitoring',
        name: 'messageMonitoring',
        component: messageMonitoring,
        meta: {
          title: '消息中心',
          active: ['messageMonitoring'],
          permission: 'monitor:task:message',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PlatformMonitor],
        },
      },
      {
        path: 'channelClassification',
        name: 'channelClassification',
        component: channelClassification,
        meta: {
          title: '注册来源管理',
          active: ['channelClassification'],
          permission: 'monitor:source',
          belong: [OperationsManagementRouteMap.OperationsManagement, OperationsManagementRouteMap.PlatformStatistics],
        },
      },
      {
        path: 'cardFrameDetails',
        name: 'cardFrameDetails',
        component: cardFrameDetails,
        hidden: true,
        meta: {
          title: '卡帧详情',
          nocache: true,
          active: ['cardFrameDetails'],
          permission: 'monitor:platform:history',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PlatformMonitor],
        },
      },
    ],
  },
]
